
import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { TypeInvoiceModel } from '../../models/configuration/type-invoice.model';
import { ConfigurationRepository } from '../../repositories/configuration.repository';
import { TypeInvoiceEntity } from '../../../data/repositories/configuration/entities/type-invoice.entity';

    export class GetTypeInvoiceUseCase implements UseCase<void, TypeInvoiceModel> {
        constructor(private config: ConfigurationRepository) { }
        execute(): Observable<TypeInvoiceEntity> {
        return this.config.getTypeInvoice();
        }
    }